import React from "react";
import MonthlyClosuresTable from "../MonthlyClosuresTable";

const OPEN_STATUS_IDS = [1, 2];

const isOpenMonth = (item) => OPEN_STATUS_IDS.includes(Number(item?.status?.id));

const PROCESS_ACTION = {
  className: "btn-green",
  icon: "fa-play",
  label: "Procesar",
  path: "/monthly-closing/open-months",
};

export default function OpenMonths({ history, dataDoctor }) {
  return (
    <MonthlyClosuresTable
      tabId={1}
      filterItem={isOpenMonth}
      action={PROCESS_ACTION}
      {...{ history, dataDoctor }}
    />
  );
}
